module.exports = __webpack_public_path__ + "logo-orkla-tagline-se-ea5d4819e77e843a0cfeb523c68aee2c.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/logo-orkla-tagline-se.svg
// module id = 71
// module chunks = 0